import React from 'react';
import { ShieldCheck } from 'lucide-react';
const steps = [{
  num: 1,
  text: 'Accedés al material inmediatamente.'
}, {
  num: 2,
  text: 'Revisás todo el contenido y los bonos.'
}, {
  num: 3,
  text: 'Evaluás si realmente te ahorra tiempo.'
}];
export function Guarantee() {
  return <section className="px-5 relative overflow-hidden" data-id="element-151">
      <div className="max-w-lg mx-auto relative z-10" data-id="element-152">
        <div className="rounded-[40px] p-4 md:p-8 border border-brand-petroleum/10 bg-[#AE0D900C]" data-id="element-153">
          <div className="flex justify-center mb-6" data-id="element-154">
            <div className="bg-brand-sage-green/10 p-3 rounded-full" data-id="element-155">
              <ShieldCheck className="text-brand-sage-green" size={40} data-id="element-156" />
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-brand-petroleum text-center mb-2 tracking-tight" data-id="element-157">
            Garantía total de 7 días
          </h2>
          <p className="text-center text-brand-medium-grey mb-4 font-semibold uppercase tracking-widest text-[10px]" data-id="element-158">
            Probalo 7 días sin riesgo. Así funciona:
          </p>

          <div className="space-y-3 mb-6" data-id="element-159">
            {steps.map(step => <div key={step.num} className="flex items-center gap-5 bg-white p-4 rounded-2xl border border-brand-petroleum/5 shadow-sm" data-id="element-160">
                <div className="bg-brand-petroleum text-white text-[10px] font-bold w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 shadow-md" data-id="element-161">
                  {step.num}
                </div>
                <span className="text-sm md:text-base font-bold text-brand-petroleum tracking-tight" data-id="element-162">
                  {step.text}
                </span>
              </div>)}
          </div>

          <div className="bg-brand-soft-cream/50 rounded-3xl p-6 md:p-8 text-center border border-brand-petroleum/5" data-id="element-163">
            <p className="text-[10px] md:text-xs text-brand-medium-grey mb-3 font-semibold uppercase tracking-widest" data-id="element-164">
              Si en 7 días sentís que esto no era lo que esperabas:
            </p>
            <p className="text-xl md:text-2xl font-bold text-brand-terracotta mb-3 tracking-tight" data-id="element-165">
              👉 Te devolvemos el 100%
            </p>
            <p className="text-[9px] text-brand-medium-grey font-medium uppercase tracking-[0.2em]" data-id="element-166">
              Sin vueltas. Sin complicaciones.
            </p>
          </div>
        </div>
      </div>
    </section>;
}